/**
 * Reordering is a WHOLE-LIST operation, not a delta: PATCH /lists/reorder
 * takes every id and 409s order_mismatch (with the server's `expected`) if the
 * set differs. This helper produces the complete new order from a single move,
 * so the client can never send a partial one.
 */
export function moveItem<T>(items: readonly T[], from: number, to: number): T[] {
  if (from === to) return [...items];
  if (from < 0 || from >= items.length || to < 0 || to >= items.length) {
    throw new RangeError(`moveItem: index out of range (${from} -> ${to} of ${items.length})`);
  }
  const next = [...items];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved as T);
  return next;
}
